import { CoworkingsByOperatorState } from './types';

export const initialState: CoworkingsByOperatorState = [];

export function coworkingsByOperator(state: CoworkingsByOperatorState = initialState) {
  return state;
}
